
import $ from "jquery"

import L from "plugins/leaflet/index"

import AppConfig from "app/config"

import AppMapZoomLevels from "app/map/zoom_levels/index"
import LeafletMapTileLayer from "app/map/leaflet/map_tile_layer"
import LeafletSettings from "app/map/leaflet/settings"


interface Selector {
  scope: string | JQuery

  map_canvas: string

  sidebar:      string
  sidebar_rows: string
}
interface InputSelector {
  scope?: string | JQuery

  map_canvas?: string

  sidebar?:      string
  sidebar_rows?: string
}
const DEFAULT_SELECTOR = {
  scope: "html",

  map_canvas: "#map-canvas",

  sidebar:      ".js-map-sidebar-toggle",
  sidebar_rows: ".map-sidebar-record-row",
}


class Map {
  protected selector: Selector

  protected $scope: JQuery
  protected $map_canvas: JQuery
  protected $sidebar: JQuery
  protected $sidebar_rows: JQuery

  protected markerImageURL: string
  protected leaflet_map?: L.Map
  protected buildingMapMarker?: L.Marker

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)

    this.$map_canvas = this.$scope.find(this.selector.map_canvas)
    this.$sidebar = this.$scope.find(this.selector.sidebar)
    this.$sidebar_rows = this.$scope.find(this.selector.sidebar_rows)

    this.markerImageURL = this.$map_canvas.data("marker")

    this.bind_action()
  }

  protected bind_action(){
    const lat = parseFloat(this.$map_canvas.data("lat"))
    const lng = parseFloat(this.$map_canvas.data("lng"))
    const myCenter = L.latLng(lat, lng)
    const zoom = parseFloat(this.$map_canvas.data("zoom"))
    const coordinates = this.$map_canvas.data("coordinates")

    const zoomControl = L.control.zoom({position: "topright"})

    // If we add map tile layer AFTER creating map object
    // The location of tile layer is drifted on load
    // pass it on map object creation
    LeafletMapTileLayer.getNewTileLayerPromise()
    .then((map_tile_layer) => {
      this.leaflet_map =
        LeafletSettings.get_use_baidu_maps() ?
          L.map("map-canvas", {
            center: myCenter,

            zoom:     zoom + 2,
            minZoom:  zoom - 2,
            maxZoom:  AppMapZoomLevels.max,

            // Interaction Options
            dragging:         false,
            touchZoom:        false,
            scrollWheelZoom:  false,
            doubleClickZoom:  false,
            boxZoom:          false,
            tap:              false,

            // Control options
            zoomControl:        false,
            attributionControl: false,

            layers: [
              map_tile_layer,
            ],
          })
          :
          L.map("map-canvas", {
            center: myCenter,

            zoom:     zoom + 2,
            minZoom:  zoom - 2,
            maxZoom:  AppMapZoomLevels.max,

            // Interaction Options
            dragging:         false,
            touchZoom:        false,
            scrollWheelZoom:  false,
            doubleClickZoom:  false,
            boxZoom:          false,
            tap:              false,

            // Control options
            zoomControl:        false,
            attributionControl: false,

            layers: [
              map_tile_layer,
            ],
          })
      const leaflet_map: L.Map = this.leaflet_map

      this.leaflet_map.addControl(zoomControl)


      if (coordinates) {
        // Polygon
        const areaPolygon = L.polygon(coordinates)
        areaPolygon.setStyle({
          color:        AppConfig.colors.blue,
          opacity:      1,
          weight:       2,
          fillColor:    AppConfig.colors.blue,
          fillOpacity:  0.3,
        })

        areaPolygon.addTo(leaflet_map)
        // Auto fit on start
        this.leaflet_map.fitBounds(areaPolygon.getBounds(), {
          animate: false,
        })

      } else {
        // Auto fit on start
        this.leaflet_map.setZoom(
          13,
          {
            animate: false,
          },
        )
      }

      // Setup map marker show
      this.$sidebar_rows.on("mouseenter", (e) => {
        const $row = $(e.currentTarget)
        const link = $row.find(".map-sidebar-record-row__link").attr("href")
        return this.setMapMarker($row.data("lat"), $row.data("lng"), link)
      })
    })
    .done()

    return this
  }

  protected setMapMarker(lat: string | number, lng: string | number, link: string) {
    if (this.buildingMapMarker && this.leaflet_map) {
      this.leaflet_map.removeLayer(this.buildingMapMarker)
    }
    this.buildingMapMarker = L.marker(
      L.latLng(parseFloat(lat.toString()), parseFloat(lng.toString())), {
        icon: L.icon({
          iconUrl:  this.markerImageURL,
          iconSize: [25, 29],
        }),
      },
    )

    this.buildingMapMarker.on("click", () => {
      window.location.href = link
    })

    if (this.leaflet_map == null) { return }

    this.leaflet_map.addLayer(this.buildingMapMarker)

    this.leaflet_map.panTo(
      this.buildingMapMarker.getLatLng(),
      {animate: false},
    )
  }
}

const Factory = {
  create(){
    return new Map()
  },
}

export {
  Factory,
}
